const show = () => {
  const toggle = document.querySelector('[data-search-show]');
  const headline = document.querySelector('[data-search-result-text]');
  const form = document.querySelector('[data-search-form]');
  if (toggle) {
    toggle.addEventListener('click', () => {
      headline.classList.add('u-hidden');
      form.classList.remove('u-hidden');
    });
  }
};

const fill = () => {
  const form = document.querySelector('.b-search__header__form');
  if (form) {
    const input = form.querySelector('.c-input__field');
    const button = form.querySelector('.c-input__submit');

    if (input) {
      input.addEventListener('input', () => {
        if (input.value === '') {
          button.classList.remove('c-input__submit--filled');
        } else {
          button.classList.add('c-input__submit--filled');
        }
      });
    }
  }
};

export default { show, fill };



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/search.js